<template>
    <div class="d-flex flex-nowrap align-center justify-center">
        <v-autocomplete v-model="valueLocal" @input="onInput" :items="items" :loading="loading" :placeholder="placeholder" :search-input.sync="search" :label="label" :rules="rules" :item-text="itemText" :item-value="itemValue" :disabled="disabled" :readonly="readonly" :dense="dense" hide-no-data cache-items :clearable="!readonly" />
        <v-btn v-if="addForm && !disabled && !readonly && canEdit(claim)" text small class="ml-1" min-width="15px" max-width="20px" @click="add"><v-icon>mdi-plus</v-icon></v-btn>
        <v-dialog v-model="dialog" max-width="500px">
            <component :is="addForm" v-model="editedItem" @input="onAdd" @cancel="closeDialog" :key="formKey" :filter="filter" />
        </v-dialog>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        props: [
            'label',
            'placeholder',
            'url',
            'value',
            'rules',
            'itemText',
            'itemValue',
            'addForm',
            'filter',
            'dense',
            'disabled',
            'readonly',
            'claim'
        ],

        data() {
            return {
                lastSearch: '',
                search: '',
                loading: false,
                autocompleteKey: 0,
                items: [],
                totalItems: [],
                dialog: false,
                editedItem: null,
                formKey: 0
            };
        },

        methods: {
            add() {
                this.formKey++;
                this.editedItem = null;
                this.dialog = true;
            },
            onAdd(item) {
                this.valueLocal = item.id;
                this.closeDialog();
            },
            closeDialog() {
                this.dialog = false;
            },
            onInput(id) {
                var filteredItems = this.totalItems.filter(i => i.id === id);
                if (filteredItems.length === 0) {
                    this.$emit('add', null);
                }
                else {
                    this.$emit('add', this.totalItems.filter(i => i.id === id)[0]);
                }
            },
            async load(search) {
                this.lastSearch = search;
                this.loading = true;

                try {
                    var params = { search };

                    if (typeof this.filter !== 'undefined' && this.filter !== null) {
                        Object.keys(this.filter).forEach(key => params['filter.' + key] = this.filter[key]);
                    }

                    var response = await axios.get(this.url, { params });

                    if (this.lastSearch === search) {
                        this.items = response.data.results;
                        this.items.forEach(i => {
                            if (!this.totalItems.map(e => e.id).includes(i.id)) {
                                this.totalItems.push(i);
                            }
                        })
                    }
                } catch {
                    // fail silently
                } finally {
                    if (this.lastSearch === search) {
                        this.loading = false
                    }
                }
            }
        },

        computed: {
            valueLocal: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                }
            }
        },

        watch: {
            async search(search) {
                if (typeof search === "undefined" || search === null) {
                    return;
                }
                this.load(search);
            },

            value: {
                immediate: true,
                async handler(value) {
                    if (typeof value === 'undefined' || value === null) {
                        this.load();
                        return;
                    }

                    var self = this;
                    if (this.items.some(i => i[self.itemValue] === value)) {
                        return;
                    }

                    var params = {};
                    params['filter.' + this.itemValue] = value;
                    params.state = 'All';
                    var response = await axios.get(this.url, { params });
                    this.items = response.data.results;
                    this.items.forEach(i => {
                        if (!this.totalItems.map(e => e.id).includes(i.id)) {
                            this.totalItems.push(i);
                        }
                    })
                }
            },

            filter: {
                async handler() {
                    await this.load(this.search);
                    this.autocompleteKey++;
                }
            }
        }
    };
</script>
